import React from 'react';
import { FaStethoscope, FaTractor, FaShieldVirus, FaNetworkWired, FaChalkboardTeacher, FaAmbulance } from 'react-icons/fa';
import TestimonialsSection from './TestimonialsSection';

const ServicesPage = () => {
  const services = [
    {
      title: 'Veterinary Care',
      description: 'Comprehensive health services for poultry, including disease diagnosis, vaccination, and treatment plans to ensure optimal flock health.',
      detail: 'Our certified vets provide 24/7 support and personalized care plans.',
      icon: <FaStethoscope className="text-primary text-2xl mb-2" />,
      image: '/assets/images/vaternity-care.jpg', // Replace with actual image path
    },
    {
      title: 'Farm Management Consulting',
      description: 'Expert advice on sustainable farming practices, productivity optimization, and resource management tailored to your farm’s needs.',
      detail: 'Get customized strategies to boost efficiency and profitability.',
      icon: <FaTractor className="text-primary text-2xl mb-2" />,
      image: '/assets/images/farming-consultation.jpg', // Replace with actual image path
    },
    {
      title: 'Disease Control',
      description: 'Proactive strategies and monitoring to prevent and manage outbreaks, ensuring the safety and longevity of your livestock.',
      detail: 'Advanced biosecurity measures to protect your flock year-round.',
      icon: <FaShieldVirus className="text-primary text-2xl mb-2" />,
      image: '/assets/images/disease-control.jpg', // Replace with actual image path
    },
      {
      title: 'IoT Services by ReNile',
      description: 'At ReNile, we provide and develop advanced IoT technologies to boost efficiency and productivity in the agricultural sector.',
      detail: 'In partnership with ReNile in the United Kingdom, we deliver a full range of ReNile services to support modern agriculture.',
      icon: <FaNetworkWired className="text-primary text-2xl mb-2" />,
      image: '/assets/images/renile.png', 
      link: 'https://renile.net/', 
    },

    {
      title: 'Training & Workshops',
      description: 'Hands-on training for farm staff on best practices in poultry care and modern farming techniques.',
      detail: 'Workshops scheduled monthly to upskill your team.',
      icon: <FaChalkboardTeacher className="text-primary text-2xl mb-2" />,
      image: '/assets/images/training.jpg',
    },
    {
      title: 'Emergency Services',
      description: '24/7 emergency response for urgent veterinary needs, ensuring rapid support for your farm.',
      detail: 'On-call experts available to handle crises at any time.',
      icon: <FaAmbulance className="text-primary text-2xl mb-2" />,
      image: '/assets/images/emergency-service.jpg', // Replace with actual image path
    },
  ];

  return (
    <>
      <header className="bg-primary text-white py-6">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-4xl font-bold">Our Services</h1>
          <p className="mt-2 text-gray-300 text-sm md:text-base">
            Discover how we support poultry farmers with expert solutions for health, management, and growth.
          </p>
          <a href="#services" className="mt-4 inline-block bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90 transition duration-300">
            Explore Services
          </a>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12">
        <section id="services" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center justify-center mb-4">{service.icon}</div>
              <h2 className="text-xl font-semibold text-primary mb-2 text-center">{service.title}</h2>
              <p className="text-gray-600 mb-2 text-center">{service.description}</p>
              <p className="text-gray-500 text-sm mb-4 text-center">{service.detail}</p>
              {service.image && (
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-70 object-cover rounded-md mb-4"
                />
              )}
              <a
                href={service.link}
                className="mt-4 inline-block text-secondary hover:underline text-center w-full"
              >
                Learn More
              </a>
            </div>
          ))}
        </section>

        <section className="mt-16 bg-gray-100 py-12">
          <TestimonialsSection />
        </section>

        <section className="mt-16 py-12">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl md:text-4xl font-bold text-primary text-center mb-8">Get in Touch</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-primary mb-4">Contact Information</h3>
                <p className="text-gray-600 mb-2">Phone: <a href="tel:+12345678900" className="text-secondary hover:underline">+44 161 566 9077</a></p>
                <p className="text-gray-600 mb-2">Email: <a href="mailto:info@chickfarm.site " className="text-secondary hover:underline">info@chickfarm.site </a></p>
                <p className="text-gray-600">Address:51 Queen Ediths Way, Cambridge, United Kingdom, CB1 8PJ</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-primary mb-4">Send Us a Message</h3>
                <form className="space-y-4">
                  <input
                    type="text"
                    placeholder="Your Name"
                    className="w-full px-4 py-2 border rounded-md text-gray-800"
                  />
                  <input
                    type="email"
                    placeholder="Your Email"
                    className="w-full px-4 py-2 border rounded-md text-gray-800"
                  />
                  <textarea
                    placeholder="Your Message"
                    className="w-full px-4 py-2 border rounded-md text-gray-800 h-24"
                  />
                  <button
                    type="submit"
                    className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90 transition duration-300"
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default ServicesPage;